import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const PartnerItemReturnList = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		setDataLoaded(true);
		// data();
	}, []);
	
	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	
	
	// const baseUrl = "http://localhost/jcphq_new";
	const { REACT_APP_API_URL } = process.env;
	console.log('Base URL', process.env.REACT_APP_API_URL);

	//search button
	const dataFilter = async () => {
        const result = await axios.get(
            // `${baseUrl}/item_return_list_report`, {
				`${process.env.REACT_APP_API_URL}/item_return_list_report`, {
            params:{
                fromdate: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                todate: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_u_idno: branchidNo,  //branchidNo
            }
        })
        setPosts(result.data.data);
    }
    
    const data = async () => {
        const res = await axios.get(
            //"https://www.breakingbadapi.com/api/characters"
			//"http://localhost/jcphq_new/public/item_return_list_report?fromdate=2015/01/01/&todate=2018/01/01/&jc_u_idno=DUBAIHQ"
		//);
		// `${baseUrl}/item_return_list_report`, {
			`${process.env.REACT_APP_API_URL}/item_return_list_report`, {
			params:{
				fromdate:'2015/01/01/', //format(dateRange.startDate, "yyyy/MM/dd/")
				todate:'2018/01/01/',   //format(dateRange.endDate, "yyyy/MM/dd/")
				jc_u_idno: 'DAVAOHQ',
			}
		})
		console.log(res);
		console.log(res.data.data);
		setPosts(res.data.data);
    };

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };
    
    const columns = [
			{
				name: "drretno",
				label: "DR Ret No",
				options: {
					filter: false,
					// display: "excluded",
				},
			},
            {
                name: "trandate",
                label: "Transaction Date",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
            // {
            //     name: "idno",
            //     label: "ID Number",
            //     options: {
            //         filter: false,
            //         // display: "excluded",
            //     },
			// },
			{
                name: "username",
                label: "Username",
                options: {
                    filter: false,
                    // display: "excluded", 
                },
            },
			{
				// name: "id",
				name: "drretno",
				// name: "idno", 
				label:"Actions",
				options: {
				  customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<NavLink to={"/reports/item-return-list/return-details/"+value}>
							<Button variant="contained" color="primary">
								View DR Return
							</Button>	
					   </NavLink> 
					);
				  },
				  download: false 
				}
			}
        ];

        const options = {
            filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                console.log(colIndex, colName, data);
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
			download: downloadFlag,  //add this
			print: downloadFlag, //add this
			downloadOptions: {
				filename : 'PartnerItemReturnList.csv' //change filename of csv
			}
			
            // tableBodyHeight,
		};
		
		const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Partner Item Return List Report</h4>
            			</div>
            			<div className="page-container">
							<div style={style}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={4} lg={3} xl={2}>
										<TextField
											id="outlined-basic"
											label="Select Date"
											variant="outlined"
											fullWidth={true}
											onFocus={() => setOpen(true)}
											autoComplete="off"
											value={`${format(
												dateRange.startDate,
												"MM/dd/yyyy"
											)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
										/>
										<DateRangePicker
											open={open}
											toggle={toggle}
											onChange={(range) => dateRangeHandler(range)}
										/> 
									</Grid>
									{/* <Grid item xs={2} style={{marginBlock: "auto"}}>
										<Input placeholder="Branch ID No" inputProps={{ 'aria-label': 'description' }} onChange={e => setbranchidNo(e.target.value)}/>
									</Grid> */}
									<Grid item xs={1} style={{marginBlock: "auto"}}>
										<Button variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
									</Grid>
								</Grid>        
							</div>
							
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            						
            								<div className="table-title">
            									Partner Item Return List Report
            								</div>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};

export default PartnerItemReturnList;